import React from 'react';
import { ClipLoader } from 'react-spinners';
import { fmt3, MSG } from './reverseHelpers';

const COLUMNS = 12;

/**
 * Single-selection grid of receipt lines. A line already in the Reversal List is badged and cannot be selected.
 * @param {{ lines: object[], loading: boolean, selectedId: string|null, inListIds: Set<string>, onSelect: (line: object) => void }} props
 */
const ReceiptLinesGrid = ({ lines, loading, selectedId, inListIds, onSelect }) => {
    const th = { whiteSpace: 'nowrap' };
    return (
        <div className="cost-center-section mt-3">
            <div className="d-flex slide-header"><div className="param-label pt-1">Receipt Lines</div></div>
            <div className="table-container" style={{ overflowX: 'auto', maxHeight: 300, overflowY: 'auto' }}>
                <table className="table table-bordered mb-0">
                    <thead className="dynoTable">
                        <tr>
                            <th style={th}>Lease No</th>
                            <th style={th}>Property No</th>
                            <th style={th}>Property</th>
                            <th style={th}>Unit No</th>
                            <th style={th}>Tenant No</th>
                            <th style={th}>Tenant</th>
                            <th style={th}>Installment</th>
                            <th style={{ ...th, textAlign: 'right' }}>Amount Paid</th>
                            <th style={th}>Voucher No</th>
                            <th style={th}>Pay Date</th>
                            <th style={th}>Pay Method</th>
                            <th style={th}>Cheque Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && (
                            <tr><td colSpan={COLUMNS} className="text-center p-3"><ClipLoader size={22} color="#6c5ce7" /></td></tr>
                        )}
                        {!loading && lines.length === 0 && (
                            <tr><td colSpan={COLUMNS} className="text-center text-muted p-3">{MSG.noLines}</td></tr>
                        )}
                        {!loading && lines.map((line) => {
                            const selected = `${line.recordId}` === `${selectedId}`;
                            const inList = inListIds.has(`${line.recordId}`);
                            return (
                                <tr
                                    key={line.recordId}
                                    className={selected ? 'table-primary' : ''}
                                    style={{ cursor: inList ? 'not-allowed' : 'pointer', opacity: inList ? 0.7 : 1 }}
                                    onClick={() => !inList && onSelect(line)}
                                    onDoubleClick={() => !inList && onSelect(line)}
                                >
                                    <td>{line.leaseNo}</td>
                                    <td>{line.propertyNo}</td>
                                    <td>{line.propertyName}</td>
                                    <td>{line.unitNo}</td>
                                    <td>{line.tenantNo}</td>
                                    <td>{line.tenantName}</td>
                                    <td>{line.installmentDesc}</td>
                                    <td style={{ textAlign: 'right' }}>{fmt3(line.amountPaid)}</td>
                                    <td>{line.voucherNo}</td>
                                    <td style={th}>{line.paymentDate}</td>
                                    <td>{line.paymentMethod}</td>
                                    <td>
                                        {line.chequeStatus}
                                        {inList && <span className="badge bg-secondary ms-2">In list</span>}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ReceiptLinesGrid;
